export default (
  duration: number | string
): { min: number; max: number } | null => {
  const stringDuration = duration.toString();

  if (stringDuration.length < 5) return null;

  const min = Number.parseInt(stringDuration.slice(1, 3));
  const max = Number.parseInt(stringDuration.slice(3, 5));

  if (min <= 0 || max <= 0 || Number.isNaN(min) || Number.isNaN(max))
    return null;

  return {
    min,
    max,
  };
};
